import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUnlockOperationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useUnlockOperation = () => {
  const [handle, { loading, error: apolloError }] =
    useUnlockOperationMutation();
  const error = useError(apolloError);

  return {
    loading,
    error,
    unlock: useCallback(
      async (id: string) => {
        const result = await handle({ variables: { id } });
        return !!result.data?.unlock;
      },
      [handle]
    ),
  };
};
